export const field =
    "w-full rounded-lg border border-white/10 bg-[var(--jr-surface-2)] px-3 py-2 text-sm text-white outline-none focus:border-[var(--jr-brand)]";
export const btn =
    "px-3 py-2 rounded-lg bg-[var(--jr-brand)] text-white text-sm font-medium disabled:opacity-40";
export const btnGhost =
    "px-3 py-2 rounded-lg border border-white/10 text-sm text-[var(--jr-text-2)] hover:text-white disabled:opacity-40";
export const card = "rounded-xl border border-white/8 bg-[var(--jr-surface)] p-4";

export const STAGES = [
    ["sourced", "Gesourced"],
    ["contacted", "Benaderd"],
    ["interested", "Interesse"],
    ["screening", "Screening"],
    ["submitted", "Voorgesteld"],
    ["placed", "Geplaatst"],
    ["declined", "Afgewezen"],
];

export function errMsg(e) {
    const d = e?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join("; ");
    return e?.message || "Mislukt";
}

export function Provenance({ row }) {
    const agent = row?.provenance_actor === "agent";
    return (
        <span
            className={`text-[10px] font-mono uppercase tracking-wider px-1.5 py-0.5 rounded ${
                agent ? "bg-[var(--jr-amber)]/15 text-[var(--jr-amber)]" : "bg-white/8 text-[var(--jr-text-2)]"
            }`}
            data-testid={`provenance-${row?.id}`}
        >
            {agent ? `agent · ${row.provenance_agent_id || ""}` : "human"}
        </span>
    );
}
